import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import UserNavbar from "./UserNavbar";
import { useNavigate } from "react-router-dom";

const ManageRuleFiles = () => {
  const navigate = useNavigate();
  const token = Cookies.get("token");
  const role = Cookies.get("role");
  const [rulesList, setRulesList] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);

  const totalPages = Math.ceil(rulesList.length / rowsPerPage);

  const paginatedRules = rulesList.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleDelete = async () => {
    if (!fileToDelete) return;

    try {
      await axios.delete(`/api/system/rules/file/${fileToDelete.filename}`, {
        headers: {
          "x-auth-token": token,
        },
      });
      setIsDeleteModalOpen(false);
      setFileToDelete(null);

      setRulesList((prev) =>
        prev.filter((f) => f.filename !== fileToDelete.filename)
      );
    } catch (error) {
      console.error("Error deleting file:", error);
      alert("Failed to delete file.");
    }
  };

  useEffect(() => {
    if (token && role) {
      if (role === "3") {
        navigate("/dashboard");
      }
    }
  }, []);

  useEffect(() => {
    if (!token) {
      navigate("/signin");
    } else {
      axios
        .get("/api/token/isLoggedIn", {
          headers: {
            "x-auth-token": token,
          },
        })
        .then((res) => console.log(res.data))
        .catch(() => navigate("/signin"));
    }
  }, []);

  useEffect(() => {
    axios
      .get("/api/system/rules/files", {
        headers: {
          "x-auth-token": token,
        },
      })
      .then((res) => setRulesList(res.data.data.affected_items))
      .catch((e) => console.error(e));
  }, []);

  return (
    <>
      <UserNavbar />

      <div className="px-4 lg:pt-10 lg:w-[80vw] xl:w-[85vw] lg:absolute lg:right-0 lg:px-6 xl:absolute xl:right-0  xl:pt-20 xl:pb-12 h-full bg-gray-50">
        <div className="border-2 border-gray-300 p-6 mt-10">
          <div className="flex justify-between items-center mb-4">
            <div>
              <h2 className="text-xl font-semibold">
                Rules files ({rulesList.length})
              </h2>
              <p className="text-gray-500 text-sm">
                From here you can manage your rules files.
              </p>
            </div>
            <div className="flex gap-4 items-center">
              {/* <button className="text-blue-600 hover:underline text-sm">
              Manage rules
            </button> */}
              <button
                className="text-blue-600 hover:underline text-sm"
                onClick={() => navigate("/addnewrule")}
              >
                <i class="ri-file-add-line pr-2"></i>
                Add new rules file
              </button>
              {/* <button className="text-blue-600 hover:underline text-sm">
              Import files
            </button>
            <button className="text-blue-600 hover:underline text-sm">
              Refresh
            </button>
            <button className="text-blue-600 hover:underline text-sm">
              Export formatted
            </button> */}
            </div>
          </div>

          {/* <div className="mb-4 flex items-center gap-2">
          <input
            type="text"
            placeholder="Search"
            className="w-full max-w-md border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
          />
          <button className="px-3 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-100">
            WQL
          </button>
          <button className="ml-auto px-4 py-2 text-sm bg-gray-100 border border-gray-300 rounded-md">
            Custom rules
          </button>
        </div> */}

          <table className="w-full text-sm text-left text-gray-700">
            <thead>
              <tr className="border-b text-gray-600">
                <th className="py-2">File</th>
                <th className="py-2">Path</th>
                <th className="py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedRules.map((file, index) => (
                <tr key={index} className="border-b hover:bg-gray-50">
                  <td className="py-2">{file.filename}</td>
                  <td className="py-2">{file.relative_dirname}</td>
                  <td className="py-2">
                    {file.relative_dirname == "etc/rules" ? (
                      <button
                        className="text-blue-600 hover:text-blue-800"
                        onClick={() => navigate(`/rule/edit/${file.filename}`)}
                      >
                        <i class="ri-pencil-line"></i>
                      </button>
                    ) : (
                      <button
                        className="text-blue-600 hover:text-blue-800"
                        onClick={() => navigate(`/rule/${file.filename}`)}
                      >
                        <i className="ri-eye-line"></i>
                      </button>
                    )}

                    {file.relative_dirname == "etc/rules" ? (
                      <button
                        className="text-blue-600 hover:text-blue-800 ml-4"
                        onClick={() => {
                          setFileToDelete(file);
                          setIsDeleteModalOpen(true);
                        }}
                      >
                        <i className="ri-delete-bin-5-line text-red-600"></i>
                      </button>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination Controls */}
          <div className="flex justify-between items-center mt-4 text-sm text-gray-600">
            <div className="flex items-center gap-2">
              <label htmlFor="rowsPerPage">Rows per page:</label>
              <select
                id="rowsPerPage"
                className="border border-gray-300 rounded px-2 py-1"
                value={rowsPerPage}
                onChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value));
                  setCurrentPage(1); // Reset to page 1
                }}
              >
                {[5, 10, 15, 20].map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex items-center gap-1">
              <button
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
                className={`px-2 py-1 rounded ${
                  currentPage === 1
                    ? "text-gray-400 cursor-not-allowed"
                    : "text-blue-600 hover:underline"
                }`}
              >
                &lt;
              </button>

              {/* Show first few pages */}
              {[...Array(totalPages)].map((_, idx) => {
                const page = idx + 1;
                if (
                  page === 1 ||
                  page === totalPages ||
                  (page >= currentPage - 1 && page <= currentPage + 1)
                ) {
                  return (
                    <button
                      key={page}
                      onClick={() => goToPage(page)}
                      className={`px-2 py-1 rounded ${
                        page === currentPage
                          ? "text-white bg-blue-600"
                          : "text-blue-600 hover:underline"
                      }`}
                    >
                      {page}
                    </button>
                  );
                } else if (
                  (page === currentPage - 2 && page > 1) ||
                  (page === currentPage + 2 && page < totalPages)
                ) {
                  return (
                    <span key={page} className="px-2">
                      ...
                    </span>
                  );
                } else {
                  return null;
                }
              })}

              <button
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`px-2 py-1 rounded ${
                  currentPage === totalPages
                    ? "text-gray-400 cursor-not-allowed"
                    : "text-blue-600 hover:underline"
                }`}
              >
                &gt;
              </button>
            </div>
          </div>
        </div>

        {isDeleteModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded shadow-lg max-w-sm w-full">
              <h2 className="text-lg font-semibold mb-4">
                Delete Confirmation
              </h2>
              <p className="text-sm text-gray-600 mb-6">
                Are you sure you want to delete{" "}
                <strong>{fileToDelete?.filename}</strong>?
              </p>
              <div className="flex justify-end gap-4">
                <button
                  className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 border border-gray-300 rounded"
                  onClick={() => {
                    setIsDeleteModalOpen(false);
                    setFileToDelete(null);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 text-sm text-white bg-red-600 hover:bg-red-700 rounded"
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ManageRuleFiles;
